import { createSelector } from 'reselect';
import { RootState } from 'MyTypes';
import { State } from './reducer';

export const selectUsersState = (state: RootState): State => state.users;

export const selectUsersData = createSelector(selectUsersState, (users) => users.users);

export const selectSearchResultsData = createSelector(selectUsersState, (users) => users.searchResults);
